import { Row } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';

export const sortBrands = (
  rowA: Row<CustomerContractInventoryGridItem>,
  rowB: Row<CustomerContractInventoryGridItem>,
  columnId: string
) => {
  const rowAValue = rowA.values[columnId];
  const rowBValue = rowB.values[columnId];
  const a = rowAValue.includes(';') ? 'Multiple' : rowAValue;
  const b = rowBValue.includes(';') ? 'Multiple' : rowBValue;
  if (a > b) return 1;
  if (a < b) return -1;
  return 0;
};
